import { styled } from 'dripsy';
import React from 'react';
import { Trans } from 'react-i18next';

import { BaseText } from './BaseText';
import { ITextTouchableProps, TextTouchable } from './TextTouchable';

interface ITextStyleProps {
  lighter?: boolean;
}

const TextButton = styled(TextTouchable)(
  (props: ITextStyleProps) => ({
    color: props.lighter ? '$background50' : '$text300',
    variant: 'text.medium',
    textAlign: 'center',
    py: '$6',
  }),
);

const Text = styled(BaseText)((props: ITextStyleProps) => ({
  color: props.lighter ? '$background0' : '$heading800',
  variant: 'text.medium',
}));

export interface IAuthNavigationTextProps
  extends ITextTouchableProps,
    ITextStyleProps {
  i18nKey: string;
}

export function AuthNavigationText({
  i18nKey,
  lighter = false,
  ...props
}: IAuthNavigationTextProps) {
  return (
    <TextButton lighter={lighter} {...props}>
      <Trans
        i18nKey={i18nKey}
        components={{
          span: <Text lighter={lighter} />,
        }}
      />
    </TextButton>
  );
}
